import { render, staticRenderFns } from "./SupportTicketCreate.vue?vue&type=template&id=6fb47cbc&scoped=true"
import script from "./SupportTicketCreate.vue?vue&type=script&lang=js"
export * from "./SupportTicketCreate.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketCreate.vue?vue&type=style&index=0&id=6fb47cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb47cbc",
  null
  
)

export default component.exports